import { cn } from '@/lib/utils';
import { senderSurfaceClass } from '@/pages/sender/components/sender-surface';

export type MetricTone = 'default' | 'muted' | 'ok' | 'bad' | 'active';

type Metric = {
	label: string;
	value: string;
	tone?: MetricTone;
};

interface SenderMetricGridProps {
	metrics: Metric[];
	columns?: 2 | 3 | 4;
}

function toneClass(tone: MetricTone | undefined): string {
	switch (tone) {
		case 'ok':
			return 'text-chart-2';
		case 'bad':
			return 'text-destructive';
		case 'active':
			return 'text-primary';
		case 'muted':
			return 'text-muted-foreground';
		default:
			return 'text-foreground';
	}
}

export default function SenderMetricGrid({ metrics, columns = 3 }: SenderMetricGridProps) {
	return (
		<div
			className='grid gap-2'
			style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
		>
			{metrics.map(metric => (
				<div key={metric.label} className={cn(senderSurfaceClass, 'flex flex-col gap-0.5 px-3 py-2.5')}>
					<p className='text-[13px] text-muted-foreground'>{metric.label}</p>
					<p className={cn('text-[15px] font-medium tabular-nums', toneClass(metric.tone))}>
						{metric.value}
					</p>
				</div>
			))}
		</div>
	);
}
